import httpClient from './httpClient';
const listAllSymbol = () => httpClient.get('/GetSymbolx');
const PostGetIssuerDetail = req => httpClient.post('/PostGetIssuerDetail', req);
const PostGetFileDownload = req => httpClient.post('/PostGetFileDownload', req,"", { responseType: 'arraybuffer' });
const GetListDownload = () => httpClient.get('/GetListDownload');
const PostDownloadForm = req => httpClient.post('/PostDownloadForm', req,"", { responseType: 'arraybuffer' });


GetListDownload
export default {
    listAllSymbol,
    PostGetIssuerDetail,
    PostGetFileDownload,
    GetListDownload,
    PostDownloadForm
};
